import { Injectable } from '@angular/core';
import { MatDateFormats } from '@angular/material/core';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class CustomDateFormatsService {
  
  constructor(private languageService: LanguageService) {}

  getDateFormats(): MatDateFormats {
    const currentLanguage = this.languageService.getCurrentLanguage();
    
    switch (currentLanguage.code) {
      case 'de-DE':
        return {
          parse: {
            dateInput: 'DD.MM.YYYY',
          },
          display: {
            dateInput: 'DD.MM.YYYY',
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'LL',
            monthYearA11yLabel: 'MMMM YYYY',
          },
        };
      
      case 'en-US':
        return {
          parse: {
            dateInput: 'MM/DD/YYYY',
          },
          display: {
            dateInput: 'MM/DD/YYYY',
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'LL',
            monthYearA11yLabel: 'MMMM YYYY',
          },
        };
      
      case 'en-GB':
      case 'fr-FR':
      case 'es-ES':
      case 'it-IT':
      default:
        return {
          parse: {
            dateInput: 'DD/MM/YYYY',
          },
          display: {
            dateInput: 'DD/MM/YYYY',
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'LL',
            monthYearA11yLabel: 'MMMM YYYY',
          },
        };
    }
  }

  getPlaceholder(): string {
    const currentLanguage = this.languageService.getCurrentLanguage();
    return currentLanguage.dateFormat;
  }
}

// Factory function to create date formats
export function dateFormatsFactory(customDateFormatsService: CustomDateFormatsService): MatDateFormats {
  return customDateFormatsService.getDateFormats();
}

// Factory function to create locale
export function dateLocaleFactory(languageService: LanguageService): string {
  return languageService.getCurrentLocale();
}